import React from 'react';
import moment from 'moment';
import _ from 'lodash';
import axios from 'axios';
import CustomToolTip from '../components/UI/ToolTip/ToolTip';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { Typography } from "@material-ui/core";
import MRDatePicker from './datePicker';
import i18n from 'i18next';
export const dateFormat = 'YYYY-MM-DD';
export const dayOfWeek = [
	{ value: 0, label: 'Sunday' },
	{ value: 1, label: 'Monday' },
	{ value: 2, label: 'Tuesday' },
	{ value: 3, label: 'Wednesday' },
	{ value: 4, label: 'Thursday' },
	{ value: 5, label: 'Friday' },
	{ value: 6, label: 'Saturday' }
];

export const checkMissingAdminValues = (adminValue, tags) => {
	if (
		// adminValue.responseTag.value === ''
		adminValue.unavailableTag.value === ''
		|| adminValue.acceptedShift.value === ''
		|| adminValue.partialShift.value === ''
		|| adminValue.partialAcceptedShift.value === ''
		|| adminValue.originalShift.value === ''
		|| adminValue.dataviewCallList.value === ''

		|| checkExistsTags(adminValue.unavailableTag.value, tags) === -1
		|| checkExistsTags(adminValue.acceptedShift.value, tags) === -1
		|| checkExistsTags(adminValue.partialShift.value, tags) === -1
		|| checkExistsTags(adminValue.partialAcceptedShift.value, tags) === -1
		|| checkExistsTags(adminValue.originalShift.value, tags) === -1) {
		return true;
	}
	for (let i = 0; i < adminValue.workShiftHours.length; i++) {
		if (adminValue.workShiftHours[i].value === "") {
			return true;
		}
	}

	return false;
}

const checkExistsTags = (tag, kronosTags) => {
	return kronosTags.find((elToFind) => tag === elToFind.value);
}

export const getValueIndex = (value, options, target) => {
	let index = 0;
	for (index = 0; index < options.length; index++) {
		if (options[index][target] === value) {
			return index;
		}
	}
	return null;
}

export const findIndex = (data, field, value) => {
	for (var i = 0; i < data.length; i += 1) {
		if (data[i][field] === value) {
			return i;
		}
	}
}

export const createAuxData = (data) => {
	let auxData = [];
	for (let i in data)
		auxData.push(Object.assign({}, data[i]))
	return auxData;
}

export const capitalize = (s) => {
	if (typeof s !== 'string') return ''
	return s.charAt(0).toUpperCase() + s.slice(1)
}

//////////////////////////// COMPONENT HELPER

export const hasError = (listOfResponses) => {
	for (let i = 0; i < listOfResponses.length; i++) {
		if (typeof listOfResponses[i].data.error !== 'undefined') {
			return true
		}
	}
	return false
}

export const createErrorMessage = (listOfResponses) => {
	let errorList = '';
	for (let i = 0; i < listOfResponses.length; i++) {
		if (typeof listOfResponses[i].data.error !== 'undefined') {
			errorList += listOfResponses[i].data.error + ': ' + listOfResponses[i].data.message + '\n';
		}
	}
	return errorList;
}

export const compareDate = (dateTimeA, dateTimeB, format) => {
	var momentA = moment(dateTimeA, format);
	var momentB = moment(dateTimeB, format);
	if (momentA > momentB) return 1;
	else if (momentA < momentB) return -1;
	else return 0;
}

export const genData = (listEE, dataview) => {
	let data = [];
	for (let i = 0; i < listEE.length; i++) {
		let found = dataview.find((elToFind) => listEE[i].eeId === elToFind.eeId);
		data.push(Object.assign({}, listEE[i], found));
	}
	return data;
}

export const isEmpty = (obj) => {
	for (var key in obj) {
		if (obj.hasOwnProperty(key))
			return false;
	}
	return true;
}

export const exists = (variable) => {
	return (typeof variable !== 'undefined') && variable !== null ? true : false
}

export const getCountDownData = (biddingStartTime, biddingEndTime, submissionEndDate, t) => {
	let countDownData = {
		message: '',
		date: biddingStartTime
	};

	if (moment(biddingStartTime).isAfter(moment())) {
		countDownData.message = t('employee.biddingTimeStartsIn');
	} else {
		if (moment(biddingEndTime).isAfter(moment())) {
			countDownData.message = t('employee.biddingTimeEndsIn');
			countDownData.date = biddingEndTime;
		} else {
			countDownData.message = moment(submissionEndDate).isAfter(moment()) ? t('employee.theBidEndsIn') : t('employee.theBidEnded');
			countDownData.date = submissionEndDate;
		}
	}

	countDownData.date = moment(countDownData.date).format('YYYY-MM-DDTHH:mm:ssZ')

	return countDownData;
}

export const hourFormat = (amount) => {
	let auxAmount = null;
	if (amount) {
		if (amount > 3600000) {
			auxAmount = amount > 86400000 ? 'DD[d] HH[h] mm[m]' : 'HH[h] mm[m]'
		}
		else
			auxAmount = 'mm[m]'
	}
	return auxAmount ? moment("1900-01-01 00:00:00").add(amount / 1000, 'seconds').format(auxAmount) : '-'
}

export const objectSize = (obj) => {
	let size = 0;
	for (let key in obj) {
		if (obj.hasOwnProperty(key)) size++;
	}
	return size;
};

export const masterRotationAuditAdd = (workPlanId, employee_id, schedule_pattern_id, effective_date, end_date, action, name, location, job, note) => {
	axios.post('/api/audit', {
		action: action,
		workPlanId: workPlanId,
		modify_by: sessionStorage.getItem('username'),
		employee_id: employee_id,
		schedule_pattern_id: schedule_pattern_id,
		effective_date: effective_date,
		end_date: end_date,
		name: name,
		location: location,
		job: job,
		note: note
	})
}

function convertArrayOfObjectsToCSV(args) {
	var result, ctr, keys, columnDelimiter, lineDelimiter, data;

	data = args.data || null;
	if (data == null || !data.length) {
		return null;
	}

	columnDelimiter = args.columnDelimiter || ',';
	lineDelimiter = args.lineDelimiter || '\n';

	keys = Object.keys(data[0]);

	result = '';
	result += keys.join(columnDelimiter);
	result += lineDelimiter;

	data.forEach(function (item) {
		ctr = 0;
		keys.forEach(function (key) {
			if (ctr > 0) result += columnDelimiter;

			result += item[key];
			ctr++;
		});
		result += lineDelimiter;
	});

	return result;
}

export function downloadCSV(args, stockData) {
	var data, filename, link;
	var csv = convertArrayOfObjectsToCSV({
		data: stockData
	});
	if (csv == null) return;

	filename = args.filename || 'export.csv';

	if (!csv.match(/^data:text\/csv/i)) {
		csv = 'data:text/csv;charset=utf-8,' + csv;
	}
	data = encodeURI(csv);
	// var encodedUri = encodeURI(csv);
	// window.open(encodedUri);
	link = document.createElement('a');
	link.setAttribute('href', data);
	link.setAttribute('download', filename);
	link.click();
}

export function getScrollbarWidth() {

	// Creating invisible container
	const outer = document.createElement('div');
	outer.style.visibility = 'hidden';
	outer.style.overflow = 'scroll'; // forcing scrollbar to appear
	outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
	document.body.appendChild(outer);

	// Creating inner element and placing it in the container
	const inner = document.createElement('div');
	outer.appendChild(inner);

	// Calculating difference between container's full width and the child width
	const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

	// Removing temporary elements from the DOM
	outer.parentNode.removeChild(outer);

	return scrollbarWidth;
}

export function getJobDescription(jobId, listJobs) {
	let foundJob = listJobs.find((elToFind) => jobId === elToFind.id);

	if (typeof foundJob !== 'undefined') {
		return ({
			description: foundJob.description,
			name: foundJob.fullName
		})
	} else {
		return ({
			description: '',
			name: ''
		})
	}
}

export function getLocationDescription(location, listLocations) {
	for (const key in listLocations) {
		if (listLocations.hasOwnProperty(key)) {
			if (listLocations[key].nodeId === location) {
				return ({
					path: listLocations[key].path,
					nodeId: listLocations[key].nodeId
				})
			}
		}
	}
	return ({
		location_path: '',
		nodeId: ''
	})
}

export const convertObjectToArray = (obj) => {
	if (_.isArray(obj)) {
		return obj;
	} else {
		let objArray = [];
		for (const key in obj) {
			if (obj.hasOwnProperty(key)) {
				objArray.push({ ...obj[key], ...{ index: objArray.length } });
			}
		}
		return objArray;
	}
}

export function calculCalendarExtremity(date, firstDayOfWeek, type) {
	return type === 'start'
		? moment(date).startOf('month').subtract(moment(date).startOf('month').day() - firstDayOfWeek, 'd')
		: moment(date).endOf('month').add(7 - moment(date).endOf('month').day() + firstDayOfWeek, 'd');
}

export const convertMinutesInTimes = (minutes) => {
	return Math.floor(minutes / 60) + ':' + ((minutes % 60) === 0 ? '00' : minutes % 60);
}

export const convertTimeInMinutes = (time) => {
	let splitTime = time.split(':');
	return parseInt(splitTime[0] * 60, 10) + parseInt(splitTime[1], 10);
}

export const displayOrgpath = (orgpath, classes, withTooltip = true) => {
	let orgpathSplit = orgpath.split('/')
	let orgpathShort = orgpath

	if (orgpathSplit.length > 3) {
		let auxIterator = 0;
		orgpathShort = '';

		for (let i = orgpathSplit.length - 1; i >= 0 && auxIterator < 3; i--) {
			orgpathShort = '/' + orgpathSplit[i] + orgpathShort
			auxIterator++
		}
		orgpathShort = orgpathSplit.length > auxIterator ? '...' + orgpathShort : orgpathShort
	}

	return !withTooltip ? orgpathShort : <CustomToolTip titletext={orgpath} jsx={<div className={classes.location}>{orgpathShort}</div>} />;
}

export const formatDurationInHHMM = (durationInMin) => {
	let nbHours = Math.floor(durationInMin / 60);

	return (nbHours < 10 ? '0' + nbHours : nbHours) + ':' + ((durationInMin % 60) === 0 ? '00' : durationInMin % 60)
}

export const formatDataviewData = (value, dataValueType, classes) => {
	switch (dataValueType) {
		case 'BOOLEAN':
			return <div className={classes.divDataviewData}>
				<FontAwesomeIcon style={{ color: value === 'False' ? 'red' : 'green' }} icon={value === 'False' ? faTimes : faCheck} />
			</div>
		default:
			return <CustomToolTip enterDelay={500} leaveDelay={500}
				titletext={value}
				jsx={<div className={classes.divDataviewData}>{value}</div>} />;
	}
}

export const genDatePicker = (classes, date, target = '', handleChangeValue = () => { }, label, fieldError = false, minDate = new Date(), maxDate, disableDates = () => { return false }, isDisabled = false, showCustomButton = false) => {
	const foreverLabel = i18n.t('workplanManager:workPlanView.global.forever');
	const selectDatePlaceholder = i18n.t('workplanManager:common.selectDate');
	let customButtonLabel = !exists(maxDate) ? '' : ((maxDate === foreverLabel || maxDate === '3000-01-01' || moment(maxDate).format('YYYY-MM-DD') === '3000-01-01') ? foreverLabel : moment(maxDate).format('YYYY-MM-DD'));
	const pickerValue = (date === foreverLabel) ? '3000-01-01' : date;

	return <div style={{ width: '100%' }}>
		<Typography className={classes.dateTypo}>
			{label}
		</Typography>
		<MRDatePicker
			minDate={minDate}
			maxDate={maxDate}
			// id={id}
			// label={label}
			placeholder={selectDatePlaceholder}
			onChange={(e, value) =>
				handleChangeValue(value, target)
			}
			value={pickerValue}
			customButtonLabel={customButtonLabel}
			showCustomButton={showCustomButton}
			customButtonValue={customButtonLabel}
			disableDates={(value) => disableDates(value, target)}
			// weekStartDay={weekStartDay}
			error={fieldError && (date === null || !exists(date))}
			disabled={isDisabled || moment(date).startOf('day') < moment().startOf('day')}
			clearable={true}
		/>
	</div>
}

export function currentHttpOptions() {
	return {
		headers: {
			Authorization: "Bearer " + sessionStorage.getItem('authToken')
		}
	}
}

